export default class StepModel {
  id = ''; // StepId
}
